<template>
  <div>
    <section>
        <v-container container--fluid>
           <v-row>
            <v-col cols="12">
              <h1 class="text-little">Bad address table</h1>
            </v-col>
           </v-row>
           <v-row :class="{'flex-column': $vuetify.breakpoint.smAndDown}">
            <v-col md="3" sm="12">
              <v-text-field v-model="search" label="Search..." prepend-inner-icon="search"></v-text-field>
            </v-col>
            <v-col md="3" sm="12">
              <v-dialog
                ref="dialogFrom"
                v-model="modalFrom"
                :return-value.sync="fromDate"
                width="290px"
              >
                <template v-slot:activator="{ on }">
                  <v-text-field
                    v-model="fromDate"
                    label="From Date"
                    prepend-icon="event"
                    readonly
                    v-on="on"
                  ></v-text-field>
                </template>
                <v-date-picker
                  v-model="fromDate"
                  scrollable :max="today"
                >
                  <v-spacer></v-spacer>
                  <v-btn text color="blue darken-1" @click="modalFrom = false">Cancel</v-btn>
                  <v-btn text color="blue darken-1" @click="$refs.dialogFrom.save(fromDate)">OK</v-btn>
                </v-date-picker>
              </v-dialog>
            </v-col>
             <v-spacer></v-spacer>
            <v-col md="3" sm="12">
              <v-switch class="justify-center" v-model="closedSwitch" :label="closedSwitch ? 'All' : 'Open'"></v-switch>
            </v-col>
           </v-row>
        </v-container>

      <v-data-table
        :search="search"
        :headers="headers"
        :items="renderedBadAddresses"
      >
        <template v-slot:item="props">
          <tr v-bind:class="{odd: props.index % 2, even: !props.index % 2}">
            <td class="text-center"
                v-for="(header, index) in headers"
                :key="index"
                v-if="header.value !== 'actions' && (header.value !== 'client' || isInternalUser)"
            >
              {{props.item[header.value]}}
            </td>
            <td v-else class="text-center">
              <v-btn icon @click="selectRow(props.item)" :disabled="props.item.closed">
                <v-icon>edit</v-icon>
              </v-btn>
            </td>
          </tr>
        </template>
      </v-data-table>
    </section>

    <GeocodeDialog
      :showProp="showGeocodeDialog"
      v-model="newLocation"
      @close="showGeocodeDialog=false"
      @done="postGeocode"
    ></GeocodeDialog>

<!--    <v-dialog v-model="editDialog" v-if="editedItem" width="500px">-->
<!--      <v-card>-->
<!--        <v-card-title>-->
<!--         <h3>Edit this address - {{editedItem.client_name}}</h3>-->
<!--        </v-card-title>-->
<!--        <v-divider></v-divider>-->
<!--        <v-card-text>-->
<!--          <v-text-field-->
<!--            readonly-->
<!--            label="Original Address"-->
<!--            v-model="editedItem.original_street1 + ', ' + editedItem.original_suburb + ' ' + editedItem.original_state + ' ' + editedItem.original_postcode"></v-text-field>-->
<!--          <v-autocomplete-->
<!--            hide-no-data-->
<!--            :search-input.sync="address"-->
<!--            label="New Address..."-->
<!--            :items="suggestedAddresses"-->
<!--            @update:searchInput="getAutoCompleteAddresses"-->
<!--          ></v-autocomplete>-->
<!--        </v-card-text>-->
<!--        <v-card-actions>-->
<!--          <v-spacer></v-spacer>-->
<!--          <v-btn text color="blue-grey lighten-2" @click="address = '';editedDialog=false; editedItem=null">Cancel</v-btn>-->
<!--          <v-btn text outlined color="blue darken-1" @click="nextStep()">Next</v-btn>-->
<!--        </v-card-actions>-->
<!--      </v-card>-->
<!--    </v-dialog>-->

<!--    <v-dialog v-model="mapDialog">-->
<!--      <v-card>-->
<!--        <v-card-title>-->
<!--          <v-tooltip top color="secondary">-->
<!--            <template v-slot:activator="{ on }">-->
<!--              <v-icon v-on="on" color="orange">warning</v-icon>-->
<!--            </template>-->
<!--            <span>Make sure you click on an address before you click on Save button</span>-->
<!--          </v-tooltip>-->
<!--         <h2 class="ml-4">Map</h2>-->
<!--        </v-card-title>-->
<!--        <v-card-text>-->
<!--           <v-row>-->
<!--            <v-col cols="12" sm="12" md="6">-->
<!--              <v-data-table-->
<!--                :headers="matchHeaders"-->
<!--                :items="matches"-->
<!--                item-key="Gnaf_ID"-->
<!--                :loading="matches.length === 0"-->
<!--              >-->
<!--                <template v-slot:headers="props">-->
<!--                  <tr @click="selected = props.item.index">-->
<!--                    <th>-->
<!--                    </th>-->
<!--                    <th-->
<!--                      v-for="header in props.headers"-->
<!--                      :key="header.text"-->
<!--                    >{{ header.text }}</th>-->

<!--                  </tr>-->
<!--                </template>-->
<!--                <v-progress-linear-->
<!--                  :indeterminate="true"-->
<!--                ></v-progress-linear>-->
<!--                <template v-slot:item="props">-->
<!--                  <tr @click="selected = props.item.index">-->
<!--                    <td align="center">-->
<!--                      <v-radio-group-->
<!--                        v-model="selected"-->
<!--                        name="rowSelector"-->
<!--                      >-->
<!--                        <v-radio :value="props.item.index"></v-radio>-->
<!--                      </v-radio-group>-->
<!--                    </td>-->
<!--                    <td style="text-align: center" v-for="(header, index) in matchHeaders" :key="index">-->
<!--                      {{props.item[header.value]}}-->
<!--                    </td>-->
<!--                  </tr>-->
<!--                </template>-->
<!--              </v-data-table>-->
<!--            </v-col>-->
<!--            <v-col cols="12" sm="12" md="6">-->
<!--              <GmapMap-->
<!--                v-if="marker !== null"-->
<!--                :center="marker"-->
<!--                :zoom="16"-->
<!--                map-type-id="terrain"-->
<!--                style="height: 300px; width: 100%"-->
<!--              >-->
<!--                <GmapMarker-->
<!--                  :position="marker"-->
<!--                  :clickable="true"-->
<!--                  :draggable="true"-->
<!--                  @drag="updateCoordinates"-->
<!--                  @click="center=marker"-->
<!--                />-->
<!--              </GmapMap>-->
<!--            </v-col>-->
<!--           </v-row>-->
<!--        </v-card-text>-->
<!--        <v-card-actions>-->
<!--          <v-spacer></v-spacer>-->
<!--          <v-btn text color="blue-grey lighten-2" @click="matches=[]; marker=null; mapDialog=false;">Cancel</v-btn>-->
<!--          <v-btn text outlined color="blue darken-1" @click="save()" :disabled="selected === null">Save</v-btn>-->
<!--        </v-card-actions>-->
<!--      </v-card>-->
<!--    </v-dialog>-->

  </div>
</template>

<script>
  import axios from 'axios'
  import GeocodeDialog from "./Search/GeocodeDialog";

  export default {
    name: "BadAddressPage",
    components: {GeocodeDialog},
    data() {
      return {
        rowIndex: null,
        // mapDialog: false,
        // address: '',
        search: '',
        fromDate: '',
        headers: [
          {text: 'Id', value: 'id', align: 'center', sortable: true},
          {text: 'Client', value: 'client_name', align: 'center', sortable: true},
          {text: 'Name', value: 'name', align: 'center', sortable: true},
          {text: 'Address', value: 'original_street1', align: 'center', sortable: false},
          {text: 'Suburb', value: 'original_suburb', align: 'center', sortable: false},
          {text: 'Postcode', value: 'original_postcode', align: 'center', sortable: false},
          {text: 'Status', value: 'status', align: 'center', sortable: false},
          {text: 'Actions', value: 'actions', align: 'center', sortable: false},
        ],
        // matchHeaders: [
        //   {text: 'Address', value: 'addressString', align: 'center', sortable: true},
        // ],
        pagination: {rowsPerPage: 25},
        badAddresses: [],
        // editDialog: false,
        editedItem: {},
        defaultItem: {},
        // suggestedAddresses: [],
        // marker: null,
        matches: [],
        closedSwitch: false,
        selected: null,
        modalFrom: false,
        showGeocodeDialog: false,
        today: new Date().toISOString().substr(0, 10),
        newLocation: null,
      }
    },
    watch: {
      selected: function(index) {
        if (index !== null) {
          this.marker = {lat: this.matches[index].Latitude, lng: this.matches[index].Longitude};
        } else this.marker = null;
      }
    },
    methods: {
      // save() {
      //   let body = this.location;
      //
      //   axios.post(process.env.API_URL + '/badaddresses/' + this.editedItem.id + '/close', body)
      //     .then((response) => {
      //       Object.assign(this.badAddresses[this.rowIndex], response.data);
      //       this.badAddresses[this.rowIndex].status = 'Closed';
      //       this.mapDialog = false;
      //       this.address = '';
      //       this.search = '';
      //       this.selected = null;
      //       this.rowIndex = null;
      //       this.editedItem = null;
      //       // this.marker = null;
      //       this.editDialog = false;
      //       this.suggestedAddresses = [];
      //     })
      // },
      // updateCoordinates(location) {
      //   this.marker = {lat: location.latLng.lat(), lng: location.latLng.lng()};
      // },
      // nextStep() {
      //   this.mapDialog = true;
      //
      //   axios.get(process.env.API_URL + '/addressify?action=autocomplete&info=true&term=' + this.address.replace(' ', '+'))
      //     .then((response) => {
      //       this.matches = this.formatMatches(response.data);
      //       this.marker = {lat: this.matches[0].Latitude, lng: this.matches[0].Longitude};
      //     })
      //     .catch(() => {
      //
      //     });
      // },
      selectRow(item) {
        this.editedItem = Object.assign({}, item);
        this.rowIndex = this.badAddresses.indexOf(item);
        this.showGeocodeDialog = true;
      },
      getBadAddresses() {
        axios.get(process.env.API_URL + '/badaddresses')
          .then((response) => {
            response.data.map((ba) => {
              return ba.status = ba.closed ? 'Closed' : 'Open';
            });
            this.badAddresses = response.data;
          })
      },
      // getAutoCompleteAddresses() {
      //   if (this.address !== null) {
      //     axios.get(process.env.API_URL + '/addressify?action=autocomplete&term=' + this.address.replace(' ', '+'))
      //       .then((response) => {
      //         if (response.status === 200) {
      //           this.suggestedAddresses = response.data;
      //         }
      //       })
      //       .catch(() => {
      //
      //       })
      //   }
      // },
      // formatMatches(list) {
      //   for (var i =0; i < list.length; i++) {
      //     list[i].addressString = list[i].StreetLine + ', ' + list[i].Suburb + ' ' + list[i].State + ' ' + list[i].Postcode;
      //     list[i].index = i;
      //   }
      //   return list;
      // },
      postGeocode(data) {
          if (data !== null) {
              this.newLocation = data;

              let body = this.newLocation;

                axios.post(process.env.API_URL + '/badaddresses/' + this.editedItem.id + '/close', body)
                  .then((response) => {
                    Object.assign(this.badAddresses[this.rowIndex], response.data);
                    this.badAddresses[this.rowIndex].status = 'Closed';
                    this.search = '';
                    this.rowIndex = null;
                    this.showGeocodeDialog = false;
                    this.editedItem = null;
                    // this.suggestedAddresses = [];
                  })
                  .catch((err) => {
                      this.$store.commit('displaySnackbar', 'Error: '+(err.response === undefined ? 'Unknown error' : err.response.data.error)) ;
                  });
          } else {
              this.$store.commit('displaySnackbar', 'Geocode failed');
          }
          this.showGeocodeDialog = false;
      },
    },
    mounted() {
      this.getBadAddresses();
    },
    computed: {
      isInternalUser() {
        return this.$store.getters['auth/isInternalUser'];
      },
      renderedBadAddresses() {
        let output = [];
        output = this.badAddresses.filter((address) => {
          return !address.closed || this.closedSwitch
        });
        return output
      }
    }

  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/pages/Delivery/BadAddressPage.vue